import React, { useState } from "react";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Grid, Box, Card, CardHeader, CardContent, Avatar } from "@mui/material";
import { MdMarkEmailRead } from "react-icons/md";
import { indigo } from "@mui/material/colors";

import RespondedTemplate from "../layout/RespondedTemplate";

const propTypes = {
  old: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};
CompletedMessagePage.prototype = propTypes;
export default function CompletedMessagePage(props) {
  const [active, setActive] = useState(null);
  let { id } = useParams();

  React.useEffect(() => {
    let index = props.old.findIndex((item) => (item.id == id ? item : null));
    setActive(props.old[index]);
  }, [id]);
  return (
    <>
      {active && (
        <Grid container direction="row" justifyContent="space-around" alignItems="center">
          <Grid item xs={12}>
            <Card className="patient-feed-card">
              <Box pt={2.5} pb={2} pl={2} pr={2}>
                <CardHeader
                  className="cpr"
                  avatar={
                    <Avatar
                      sx={{
                        color: indigo[900],
                        bgcolor: "#f6f6f6",
                      }}
                    >
                      <MdMarkEmailRead />
                    </Avatar>
                  }
                  title={active.title}
                  subheader={new Date(active.created_at).toDateString()}
                />
              </Box>

              <CardContent className="bt">
                <Box p={2} pl={3} color="#014361" className="bb">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: active.header,
                    }}
                  />{" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: active.body,
                    }}
                  />
                </Box>
                <Box pl={3} p={2} ml={1}>
                  <RespondedTemplate
                    questions={[...active.questions]}
                    date={active.date_responded}
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
}
